import React from 'react';
import Layout from '../components/Layout';
import './Features.css';

const features = [
  {
    title: 'Live Camera Scanning',
    description: 'No need to take a photo. Just point your camera at your monitor, and the app reads the numbers in real-time.',
    icon: '📷'
  },
  {
    title: 'Seamless Apple Health Sync',
    description: 'Save your systolic, diastolic, and heart rate data directly and securely to Apple Health with a single tap.',
    icon: '❤️'
  },
  {
    title: 'Siri & Shortcuts Integration',
    description: 'Simply say, "Hey Siri, log blood pressure," to launch the scanner instantly for a truly hands-free experience.',
    icon: '🎤'
  },
  {
    title: 'Privacy First',
    description: 'All scanning and analysis happens on your device. Your health data is never sent to a server, and we collect no personal information.',
    icon: '🛡️'
  }
];

const Features = () => {

  return (
    <Layout>
      <section className="features-section">
        <h2>Core Features of Tonometer Scan</h2>
        <p>Experience the future of blood pressure monitoring with these key features</p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default Features;